// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"vd__1R9Ai","form":"vd__3eh7_","footer":"vd__16gaN"};